export default __webpack_public_path__ + "static/media/gallery_03.320ed5d0.jpg";